import React, { useState } from "react";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";
import toast from "../../utils/toast";
import InputDefault from "../Form/InputDefault";
import MaskedInputDefault from "../Form/MaskedInputDefault";
import { useIntl } from "react-intl";
import { styles } from "./styles";
import { FormattedMessage } from "react-intl";

const CreditCardForm = ({ onSubmit, submitText }) => {
  const [name, setName] = useState("");
  const [numberCard, setNumberCard] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [ccv, setCcv] = useState("");

  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [phone, setPhone] = useState("");
  const intl = useIntl();
  async function saveCard() {
    if (!name) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaNome" }),
        "#DA1414"
      );
      return false;
    }

    if (!numberCard) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaNumeroCartao" }),
        "#DA1414"
      );
      return false;
    }

    if (!expirationDate) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaValidadeCartao" }),
        "#DA1414"
      );
      return false;
    }

    if (!ccv) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchacvvCartao" }),
        "#DA1414"
      );
      return false;
    }

    if (!email) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaEmailPortador" }),
        "#DA1414"
      );
      return false;
    }

    if (!cpfCnpj) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaCpf" }),
        "#DA1414"
      );
      return false;
    }

    if (!postalCode) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaCep" }),
        "#DA1414"
      );
      return false;
    }

    if (!addressNumber) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaEndereco" }),
        "#DA1414"
      );
      return false;
    }

    if (!phone) {
      toast(
        intl.formatMessage({ id: "creditcardform.preenchaTelefone" }),
        "#DA1414"
      );
      return false;
    }

    const [month, year] = expirationDate.split("/");

    const data = {
      creditCard: {
        holderName: name,
        number: numberCard,
        expiryMonth: month,
        expiryYear: year,
        ccv,
      },
      creditCardHolderInfo: {
        name,
        email,
        cpfCnpj,
        postalCode,
        addressNumber,
        phone,
      },
    };

    onSubmit(data);
  }

  return (
    <ScrollView>
      <View style={styles.container}>
        <Text style={styles.mainHeaderTxt}>
          <FormattedMessage id="newCard.headerAdicionaCartao" />
        </Text>
        <FormattedMessage id="creditcardform.nomeCompleto">
          {(placeholder) => (
            <InputDefault
              value={name}
              onValueChange={(value) => setName(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.numeroCartao">
          {(placeholder) => (
            <MaskedInputDefault
              mask="9999 9999 9999 9999"
              keyboardType="numeric"
              value={numberCard}
              onValueChange={(value) => setNumberCard(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.validade">
          {(placeholder) => (
            <MaskedInputDefault
              mask="99/9999"
              keyboardType="numeric"
              value={expirationDate}
              onValueChange={(value) => setExpirationDate(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.cvv">
          {(placeholder) => (
            <MaskedInputDefault
              mask="9999"
              keyboardType="numeric"
              value={ccv}
              onValueChange={(value) => setCcv(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <Text style={styles.holderTitle}>
          <FormattedMessage id="creditcardform.dadosPortador" />
        </Text>

        <FormattedMessage id="creditcardform.email">
          {(placeholder) => (
            <InputDefault
              value={email}
              onValueChange={(value) => setEmail(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.cpfCnpj">
          {(placeholder) => (
            <MaskedInputDefault
              mask="999.999.999-99"
              keyboardType="numeric"
              value={cpfCnpj}
              onValueChange={(value) => setCpfCnpj(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.cep">
          {(placeholder) => (
            <MaskedInputDefault
              mask="99.999-999"
              keyboardType="numeric"
              value={postalCode}
              onValueChange={(value) => setPostalCode(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.numero">
          {(placeholder) => (
            <InputDefault
              value={addressNumber}
              keyboardType="numeric"
              onValueChange={(value) => setAddressNumber(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <FormattedMessage id="creditcardform.telefone">
          {(placeholder) => (
            <MaskedInputDefault
              mask="(99) 99999-9999"
              keyboardType="numeric"
              value={phone}
              onValueChange={(value) => setPhone(value)}
              placeholder={placeholder}
            />
          )}
        </FormattedMessage>

        <View style={styles.contentBtn}>
          <TouchableOpacity onPress={saveCard} style={styles.button}>
            <Text style={{ color: "#FFFFFF" }}>{submitText}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ScrollView>
  );
};

export default CreditCardForm;
